export const MAX_HEIGHT = 480;
//# sourceMappingURL=constants.js.map